var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-progress',{attrs:{"value":_vm.value,"max":_vm.max,"variant":_vm.variant,"animated":_vm.animated}}),_vm._v(" "+_vm._s(_vm.maxValue)+"% ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }